import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksDe = () => {
    return <HowStartpageWorks languageCode="de" />
}

export default HowStartpageWorksDe
